import { cn } from 'lib/utils'
import type { DefaultCardProps } from './types'
import { CardHeader, CARD_BASE_CLASS } from '../shared'

import './index.scss'

const mainClass = 'card'

export const DefaultCardVariant = ({
  title,
  image,
  text,
  modifier,
}: DefaultCardProps) => {
  return (
    <div className={cn(mainClass, modifier, CARD_BASE_CLASS)}>
      <CardHeader title={title} image={image} mainClass={mainClass} />
      {text && <div className={`${mainClass}__content`}>{text}</div>}
    </div>
  )
}
